import React from "react";

export function GanttLegend({ workstations }) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3 border border-t-0 border-line rounded-b-sm bg-surface2">
      {workstations.map((w) => (
        <div key={w.id} className="flex items-center gap-1.5">
          <span className="w-3 h-3 rounded-sm border border-black/40" style={{ backgroundColor: w.color }} />
          <span className="text-[11px] text-muted">{w.name}</span>
        </div>
      ))}
      <div className="flex items-center gap-1.5">
        <span className="w-3 h-3 rounded-sm border border-dashed border-white/25 bg-[#2A2A2C]" />
        <span className="text-[11px] text-muted">Meal break</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="w-3 h-3 rounded-sm diag-hatch border border-critical/50" />
        <span className="text-[11px] text-muted">Absence</span>
      </div>
    </div>
  );
}
